export { Label, renderLabel, useLabel } from './components/Label/index';
export type { LabelSlots, LabelProps, LabelState } from './components/Label/index';
